export function openDeepLink(path: string, query?: Record<string, string>, host?: string) {
    if (!host) {
        // 根据userAgent判断所在app
        host = (navigator.userAgent.toLowerCase().includes('community') ? 'zests' : 'newsbreak');
    }
    const deepLink = document.createElement('a');
    //拆分base和query
    const { base, obj } = safeUrl(path);
    //合并query
    query = { ...obj, ...query };
    //拼接base和query（encode）
    if (query) {
        deepLink.href = `${host}://${base}?`;
        Object.entries(query).forEach(([key, value], index) => {
            deepLink.href += `${key}=${encodeURIComponent(value)}`;
            if (index < Object.entries(query).length - 1) {
                deepLink.href += `&`;
            }
        });
    }
    else {
        deepLink.href = `${host}://${base}`;
    }

    document.body.appendChild(deepLink);
    if (window.location.hostname === 'localhost') {
        console.table({ path, query, host })
        console.log(deepLink)
        return;
    }
    deepLink.click();
    document.body.removeChild(deepLink);
}
export function nbFollow(
    callback: (res: any) => void,
    mediaId: number,
    mediaAccount: string | undefined | null,
    mediaAvatar: string | undefined | null,
    follow: 0 | 1,
) {
    invoke('follow', { mediaId, mediaAccount, mediaAvatar, follow }, callback);
}
export function nbGetLoginInfo(callback: (res: any) => void) {
    invoke('getLoginInfo', {}, callback);
}

export function invoke(action: string, payload: any, callback: (res: any) => void) {
    (window as any).NBCallback = (window as any).NBCallback || {};
    const callbackFunc = `${action}_${Math.random().toString(36).substring(2, 8)}`;
    (window as any).NBCallback[callbackFunc] = (res: any) => {
        if (res.success === 'True' || res.success === true) {
            res.success = 1;
        }
        if (res.success === 'False' || res.success === false) {
            res.success = 0;
        }
        if (res.isGuest === 'True' || res.isGuest === true) {
            res.isGuest = 1;
        }
        if (res.isGuest === 'False' || res.isGuest === false) {
            res.isGuest = 0;
        }
        callback(res);
        delete (window as any).NBCallback[callbackFunc];
    };
    if ((window as any).NBJS && (window as any).NBJS.callNative) {
        (window as any).NBJS.callNative(
            JSON.stringify({
                action: action,
                callback: `window.NBCallback.${callbackFunc}`,
                ...payload,
            }),
        );
    } else {
        eval(
            `window.NBCallback.${callbackFunc}({success:-1,errMsg:'${callbackFunc}: not in app'})`,
        );
    }
}

export function safeUrl(url: string) {
    const [base, query] = url.split("?");
    const queryObj: any = {}
    query?.split("&").map((pair: string) => {
        const [key, value] = pair.split("=");
        queryObj[key] = value;
    });
    return {
        base,
        obj: queryObj
    }
}